var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8652 17.1888L22.5496 17.188C21.8291 17.188 21.2451 17.7719 21.2451 18.4924V23.7045C21.2451 24.4248 21.8291 25.0088 22.5495 25.0088H31.7375C30.7314 27.6199 28.8536 29.8065 26.4578 31.1959L30.3755 37.9778C36.66 34.3432 40.3755 27.966 40.3755 20.827C40.3755 19.8106 40.3006 19.0839 40.1507 18.2657C40.0368 17.6441 39.4971 17.1888 38.8652 17.1888Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3761 32.8402C15.8797 32.8402 11.9544 30.3834 9.84617 26.748L3.06445 30.657C6.51562 36.6384 12.9808 40.6663 20.3761 40.6663C24.004 40.6663 27.4272 39.6895 30.3761 37.9872V37.9779L26.4584 31.1959C24.6663 32.2352 22.5926 32.8402 20.3761 32.8402Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.376 37.9871V37.9778L26.4582 31.1958C24.6662 32.2351 22.5926 32.8401 20.376 32.8401V40.6662C24.0039 40.6662 27.4272 39.6894 30.376 37.9871Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20207 20.6662C8.20207 18.4499 8.80691 16.3764 9.84606 14.5844L3.06434 10.6755C1.3527 13.6151 0.375977 17.0291 0.375977 20.6662C0.375977 24.3034 1.3527 27.7173 3.06434 30.6569L9.84606 26.748C8.80691 24.9561 8.20207 22.8826 8.20207 20.6662Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3761 8.49235C23.3082 8.49235 26.0015 9.53423 28.1052 11.2673C28.6241 11.6948 29.3784 11.6639 29.8538 11.1885L33.5468 7.49556C34.0862 6.95618 34.0477 6.07329 33.4716 5.57345C29.947 2.51571 25.361 0.66626 20.3761 0.66626C12.9808 0.66626 6.51562 4.69415 3.06445 10.6756L9.84617 14.5845C11.9544 10.9491 15.8797 8.49235 20.3761 8.49235Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.105 11.2673C28.624 11.6948 29.3784 11.6639 29.8537 11.1885L33.5467 7.49556C34.086 6.95618 34.0475 6.07329 33.4714 5.57345C29.9468 2.51563 25.3609 0.66626 20.376 0.66626V8.49235C23.308 8.49235 26.0014 9.53423 28.105 11.2673Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.375977 0.66626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.54508a36cf70379b82eabc7a33982a45.svg";
export { ForwardRef as ReactComponent };